export const getJwtUrl = (continueUrlString: string | null) => {
  if (!continueUrlString) return;

  const jwtUrl = `${import.meta.env.VITE_URL}${
    location.pathname
  }&${continueUrlString}`;
  const continueUrl = new URL(jwtUrl);

  return continueUrl.searchParams.get("jwt");
};
